import { useEffect, useRef } from "react";

import { PageMeta, pushPageMeta, removePageMeta, updatePageMeta } from "@/lib/pageMeta";

/**
 * Sets this page's title, description, canonical, robots and JSON-LD while it is mounted.
 * The site name and default description come from the brand (lib/pageMeta).
 */
export const usePageMeta = (meta: PageMeta) => {
  const id = useRef<number | null>(null);
  // Compared by value so an inline object does not rewrite the head on every render.
  const key = JSON.stringify(meta);

  useEffect(() => {
    const value = JSON.parse(key) as PageMeta;
    if (id.current === null) id.current = pushPageMeta(value);
    else updatePageMeta(id.current, value);
  }, [key]);

  useEffect(
    () => () => {
      if (id.current !== null) removePageMeta(id.current);
      id.current = null;
    },
    [],
  );
};
